const DetailFields = {
  List: function List({ children }: { children: React.ReactNode }) {
    return (
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-2 text-xs text-gray-500 dark:text-gray-400">{children}</div>
      </div>
    );
  },

  Item: function Item({ label, children }: { label: string; children: React.ReactNode }) {
    return (
      <div className="flex items-center justify-between">
        <div className="text-xs font-semibold">{label}</div>
        <div>{children}</div>
      </div>
    );
  },
};

export default DetailFields;
